'use client';

import BookDemo from '@/components/BookDemo';
import Hero from '@/components/Hero';
import PreviewPriceIndex from '@/components/PreviewPriceIndex';
import ProBenefitsDisplay from '@/components/ProBenefits';
import ProHowItWorks from '@/components/ProHowItWorks';
import ProServices from '@/components/ProServices';
import TestimonialsDisplay from '@/components/TestimonialsDisplay';
import WhatIsPro from '@/components/WhatIsPro';
import LogoExclamationRectangle from '@/illustrations/LogoExclamationRectangle';
import type { Area } from '@/types/booliApi';

interface LandingPage {
  areas?: Area[];
}
export default function LandingPage({ areas }: LandingPage) {
  return (
    <>
      <Hero />
      <main
        className='overflow-x-hidden'
        data-smooth-scroll
      >
        <div className='mobile:px-4 relative z-10 m-auto mt-32 flex max-w-7xl flex-col px-10'>
          <section
            id='what-is-pro'
            className='w-full scroll-mt-25'
          >
            <WhatIsPro />
          </section>
          <section
            id='services'
            className='tablet:mt-20 mt-40 scroll-mt-25'
          >
            <ProServices />
          </section>
          <section
            id='pro-explained'
            className='tablet:mt-20 mt-40 scroll-mt-25'
          >
            <ProHowItWorks />
          </section>
          <section
            id='benefits'
            className='tablet:mt-20 -z-10 mt-40 w-full scroll-mt-25'
          >
            <ProBenefitsDisplay />
          </section>
          {areas && (
            <section
              id='hpi'
              className='tablet:mt-20 mt-48 scroll-mt-25'
            >
              <PreviewPriceIndex areas={areas} />
            </section>
          )}
          <section
            id='testimonials'
            className='tablet:mt-10 mt-20 scroll-mt-25'
          >
            <TestimonialsDisplay />
          </section>
          <section
            id='demo'
            className='tablet:mt-20 mt-40'
          >
            <BookDemo />
          </section>
          <LogoExclamationRectangle className='tablet:hidden absolute top-0 right-0 -z-10 w-[85%] opacity-50' />
        </div>
      </main>
    </>
  );
}
